export default __webpack_public_path__ + "static/media/jwl-4.3a883c0c.png";